import { useDispatch, useSelector } from 'react-redux';

import * as Store from 'store';

import * as Selectors from '../selectors';
import * as Types from '../types';
import { useEffect } from 'react';
import * as Actions from '../actions';

interface IChildren {
  item: Types.IEntity.StaticPage;
  isFetched: boolean;
}

interface IProps {
  slug: string;
  onSuccess?: () => void;
  onError?: () => void;
  onFinally?: () => void;
}

const useSingle = ({ slug, onSuccess = () => {}, onError = () => {}, onFinally = () => {} }: IProps): IChildren => {
  const dispatch = useDispatch();

  const item = useSelector<Store.Types.IState, Types.IEntity.StaticPage>(state => Selectors.getSingle(state, slug));
  const isFetched = useSelector<Store.Types.IState, boolean>(state => state.staticPage.single.isFetched);

  useEffect(() => {
    dispatch(
      Actions.Single.request({
        slug,
        callback: {
          onSuccess,
          onError,
          onFinally
        }
      })
    );
  }, [slug]);

  return { item, isFetched };
};

export default useSingle;
